import { render } from "./ProposalList.vue?vue&type=template&id=2b58b3a4"
import script from "./ProposalList.vue?vue&type=script&lang=js"
export * from "./ProposalList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__